import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { availableItemsTabs } from "@/components/lib/SidebarLinks";

const initialState = {
    id: 1,
    title: "Drinks",
    path: "drinks",
    updateLoading: false,
    requestStatus: false,
    error: null,
    success: null,
};

const availableItemSlice = createSlice({
    name: "availableItems",
    initialState,
    reducers: {
        selectedTab: (state, action) => {
            const selectedItem = availableItemsTabs.find(
                (item) => item.id === action.payload
            );

            if (selectedItem) {
                state.id = selectedItem.id;
                state.title = selectedItem.title;
                state.path = selectedItem.path;
            }
        },
    },
});

export const { selectedTab } = availableItemSlice.actions;
export default availableItemSlice.reducer;
